<div class="hotel-container">
  <mat-card class="no-shadow">
    <mat-card-header>
      <mat-card-title class="no-subtitle">
        <mat-icon inline="true" class="opacity-4">hotel</mat-icon>
        Hotel
      </mat-card-title>
      <mat-card-title>
        <button mat-icon-button color="primary" (click)="onCloseDialog()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <app-hotel-info [dutyPeriodIndex]="data.dutyPeriodIndex"></app-hotel-info>
    </mat-card-content>
  </mat-card>
</div>